
import React from 'react';
import { Image } from 'react-bootstrap';
import {ReactComponent as MapMarker} from '../MapMarker.svg';

function Spacer(props) {

    return (
        <div style={{height: props.height}}></div>
    );
}

function getFullDayFormattedDate(label, dateString) {
    if(dateString) {
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var date = new Date(dateString);
        return label + " " + date.toLocaleDateString(undefined, options);
    }
    else {
        return "";
    }
}

function GeoApifyMap(props) {
    var mapMarkerWidth = props.width / 7;
    var mapMarkerHeight = props.height / 6;
    var widthOffset = (props.width - mapMarkerWidth) / 2;
    var heightOffset = (props.height / 2) - mapMarkerHeight;
    var googleLink = "https://maps.google.com/?q="+props.latitude+","+props.longitude;
    return (
        <div>
            <a href={googleLink} target="_blank">

            <div style={{position: "absolute", paddingLeft: widthOffset+"px", paddingTop: heightOffset+"px"}}>
                <MapMarker height={mapMarkerHeight+"px"}></MapMarker>
            </div>
            <Image src={getImgKitUrlForMap(props.width, props.height, props.longitude + "," + props.latitude, props.zoom)} />
            </a>
        </div>
    );
}
function getImgKitUrlForMap(width, height, center, zoom) {
    if(!width || !height) {
        return "";
    }

    var geoApifyString = "?style=osm-carto";
    geoApifyString += "&width=" + width
    geoApifyString += "&height=" + height;
    geoApifyString += "&center=lonlat:" + center;
    geoApifyString += "&zoom=" + zoom;
    geoApifyString += "&marker=lonlat:" + center + ";";
    geoApifyString += "color:%23ff0000;"
    geoApifyString += "size:medium";
    geoApifyString += "&apiKey=259012bc70854a6588f4120b92ae7a1a"

    return "https://ik.imagekit.io/pof18emuc45/geoapify/" + geoApifyString;
}

function addParameter(currentParameterString, newParameterPrefix, newParameterValue) {
    if(!newParameterValue) {
        return currentParameterString;
    }
    if(currentParameterString.length > 0) {
        currentParameterString += ",";
    }
    return currentParameterString + newParameterPrefix + "_" + newParameterValue;
}
function getCloudinaryUrlFromKey(imgKey, width, height, isProfile, isFetch) {
    var pixelRatio = window.devicePixelRatio;
    var transformationParam = "";
    transformationParam = addParameter(transformationParam, "w", width*pixelRatio);
    transformationParam = addParameter(transformationParam, "h", height*pixelRatio);

    if(isProfile) {
        transformationParam = addParameter(transformationParam, "c", "thumb");
        transformationParam = addParameter(transformationParam, "g", "face");
        transformationParam = addParameter(transformationParam, "r", "max");
    }
    else {
        transformationParam = addParameter(transformationParam, "c", "fill");
    }
    transformationParam = transformationParam + "/";
    var fetchOrUploadParam = "upload/";
    if(isFetch) {
        fetchOrUploadParam = "fetch/";
    }
    if(imgKey) {
        var cloudName = (typeof process !== "undefined" && process.env && process.env.REACT_APP_CLOUDINARY_CLOUD_NAME) || "dvqt2rsla";
        var cdnUrl = "https://res.cloudinary.com/" + cloudName + "/image/" + fetchOrUploadParam + transformationParam + imgKey;
        if(cdnUrl.length > 0) {
            return cdnUrl;
        }
    }
    return null;
}

export { Spacer, getFullDayFormattedDate, getCloudinaryUrlFromKey, GeoApifyMap };
